
import request from "@/CommonDP/utils/request";
import { mongeApp } from "@/CommonDP/mongeView/store/mongeStore";

export async function getShareToken() {
  if (mongeApp.shareToken) {
    return mongeApp.shareToken;
  } else {
    const res = await createShareToken();
    mongeApp.shareToken = res.data;
    return res.data;
  }
}
function createShareToken() {
  return request.post(`/doc/shareNew/createShareToken?id=${encodeURIComponent(mongeApp.shareId)}`).then((res) => res);
}
